import useFetchedData from 'hooks/useFetchedData';
import { useMemo } from 'react';
import { getStaticConfig, prepareConfig } from 'utils/config';

function useFetchedConfig(url) {
  const { data } = useFetchedData(url);

  return useMemo(() => {
    if (!url) {
      return {};
    }
    if (!data) {
      return getStaticConfig();
    }
    return prepareConfig(data.data);
  }, [data, url]);
}

export default useFetchedConfig;
